export default "__VITE_ASSET__BQEqGQQa__"